import { teacherServiceURL } from '../endpoint';

export const schoolCreateURL = () => {
  return new URL(`schools/`, teacherServiceURL);
};
